/* src/app/pages/filter/filter.page.scss */
ion-card {
  max-height: calc(100vh - 80px - 24px);
  overflow-y: auto;
  background: var(--ion-color-light);
  box-shadow: var(--yf-shadow);
  display: flex;
  flex-direction: column;
  gap: 12px;
}
@media (max-width: 576px) {
  ion-card {
    width: -webkit-fill-available;
    max-width: 360px;
  }
}
@media (min-width: 576px) {
  ion-card {
    width: 360px;
  }
}
.card-body {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
.card-footer {
  display: flex;
  justify-content: center;
  margin-top: auto;
}
.reset-btn {
  --background:
    linear-gradient(
      135deg,
      #0f172a,
      #1f2937);
  --background-hover:
    linear-gradient(
      135deg,
      #111827,
      #111827);
  --border-radius: 14px;
  --padding-start: 16px;
  --padding-end: 16px;
  --box-shadow: 0 8px 18px rgba(0,0,0,0.18);
  letter-spacing: 0.4px;
  font-weight: 700;
  text-transform: none;
}
.error {
  display: flex;
  justify-content: space-between;
  color: #c5000f;
  align-items: center;
}
/*# sourceMappingURL=filter.page.css.map */
